import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';

export default SingleAction;
